import { Tag as CarbonTag } from '@carbon/react';
import { cx } from '../../utils';
import styles from './CdStatusTag.module.scss';

export type StatusTone = 'success' | 'warning' | 'danger' | 'info' | 'neutral' | 'lapsed';

type CarbonTagType = 'green' | 'warm-gray' | 'red' | 'blue' | 'gray';

const toneToType: Record<Exclude<StatusTone, 'lapsed'>, CarbonTagType> = {
  success: 'green',
  warning: 'warm-gray',
  danger: 'red',
  info: 'blue',
  neutral: 'gray',
};

export interface CdStatusTagProps {
  label: string;
  tone?: StatusTone;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * Read-only status pill ("Lapsed", "Issued", "In review"…).
 * Domain statuses are mapped to tones in the app, keeping this component domain-free.
 */
export const CdStatusTag = ({
  label,
  tone = 'neutral',
  size = 'md',
  className,
}: CdStatusTagProps) => {
  return (
    <CarbonTag
      size={size}
      type={tone === 'lapsed' ? undefined : toneToType[tone]}
      className={cx(styles.status, tone === 'lapsed' && styles.lapsed, className)}
    >
      {label}
    </CarbonTag>
  );
};
